import {
  ZONE_STAGE_ARRIVAL_MS,
  ZONE_STAGE_HOLD_FAST_MS,
  ZONE_STAGE_HOLD_MS,
  ZONE_STAGE_JUMP_FAST_MS,
  ZONE_STAGE_JUMP_MS,
  ZONE_STAGE_LONG_CHAIN_LINKS,
} from './constants';

export interface ZoneStageTiming {
  /** Moment, w którym marker ląduje na kolejnym ogniwie – jeden wpis na ogniwo. */
  arrivals: number[];
  /** Postój na odsłonięciu/odbiciu strefy. */
  holdMs: number;
  /** Przejazd do następnej strefy w łańcuchu. */
  jumpMs: number;
  /** Kiedy inscenizacja się kończy i marker idzie na wynik rozliczony. */
  totalMs: number;
}

/**
 * Harmonogram inscenizacji łańcucha stref. Jedno źródło dla animacji na torze i dla
 * dźwięków – rozjechanie się tych dwóch daje wrażenie zepsutej gry, a dwie kopie
 * arytmetyki czasu rozjeżdżają się przy pierwszej zmianie stałych.
 *
 * Pierwszy dojazd jest zgrany z czasem przejazdu markera; kolejne ogniwa lecą szybciej,
 * a długi łańcuch (możliwy przy pętli) przechodzi w tempo ekspresowe, żeby najgorszy
 * przypadek nie zamienił się w kilkunastosekundowy pokaz.
 */
export function zoneStageTiming(linkCount: number): ZoneStageTiming {
  const express = linkCount > ZONE_STAGE_LONG_CHAIN_LINKS;
  const holdMs = express ? ZONE_STAGE_HOLD_FAST_MS : ZONE_STAGE_HOLD_MS;
  const jumpMs = express ? ZONE_STAGE_JUMP_FAST_MS : ZONE_STAGE_JUMP_MS;

  const arrivals: number[] = [];
  let at = ZONE_STAGE_ARRIVAL_MS;
  for (let index = 0; index < linkCount; index += 1) {
    arrivals.push(at);
    at += holdMs;
    if (index < linkCount - 1) at += jumpMs;
  }

  return { arrivals, holdMs, jumpMs, totalMs: at };
}
